import { IGeneralAPI } from 'store/states/general.state'
import api from '../index'

const getGeneral = () => {
  return api.get<IGeneralAPI>('general/settings')
}

export default getGeneral
